module.exports = __webpack_public_path__ + "static/logo-american-express-970fad3bcede1a3a05d6ec9f804f7c9e.png";